import { render, staticRenderFns } from "./PronunciationSkillList.vue?vue&type=template&id=b01bc11a&scoped=true&"
import script from "./PronunciationSkillList.vue?vue&type=script&lang=js&"
export * from "./PronunciationSkillList.vue?vue&type=script&lang=js&"
import style0 from "./PronunciationSkillList.vue?vue&type=style&index=0&id=b01bc11a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01bc11a",
  null
  
)

export default component.exports